import { PricingDisplayResponseBuilder } from 'gql/autogen/PricingDisplayResponseBuilder';
import { SummaryElementResponseBuilder } from 'gql/autogen/SummaryElementResponseBuilder';
import { DisplayTotalPriceResponseBuilder } from 'gql/autogen/DisplayTotalPriceResponseBuilder';
import { ChargeAmountResponseBuilder } from 'gql/autogen/ChargeAmountResponseBuilder';
import { LoyaltyOfferResponseBuilder } from 'gql/autogen/LoyaltyOfferResponseBuilder';
import { BurnLoyaltyOfferResponseBuilder } from 'gql/autogen/BurnLoyaltyOfferResponseBuilder';
import { EarnLoyaltyOfferResponseBuilder } from 'gql/autogen/EarnLoyaltyOfferResponseBuilder';
import { BadgesResponseBuilder } from 'gql/autogen/BadgesResponseBuilder';
import { BadgeResponseBuilder } from 'gql/autogen/BadgeResponseBuilder';
import { DisplayPromocodeItemResponseBuilder } from 'gql/autogen/DisplayPromocodeItemResponseBuilder';

export const buildPricingDisplayResponseBuilder = (withPerPax = true) => {
    const pricingResponseBuilder = new PricingDisplayResponseBuilder().withPerBook(
        new SummaryElementResponseBuilder()
            .withDisplayType()
            .withQuantity()
            .withTotal(
                new DisplayTotalPriceResponseBuilder()
                    .withExclusive(new ChargeAmountResponseBuilder().withChargeTotal().withCrossedOut())
                    .withAllInclusive(new ChargeAmountResponseBuilder().withChargeTotal().withCrossedOut()),
            )
            .withLoyaltyOffers(
                new LoyaltyOfferResponseBuilder()
                    .withLoyaltyOfferType()
                    .withLoyaltyToken()
                    .withEarnOffer(new EarnLoyaltyOfferResponseBuilder().withPoints())
                    .withBurnOffer(new BurnLoyaltyOfferResponseBuilder().withPoints().withUserPayableAmount().withItemPriceInPoints()),
            )
            .withPromocodeItems(new DisplayPromocodeItemResponseBuilder().withPromotionCode().withDiscountedValue().withIsApplied().withIsAllowPricePeek().withIsAutoApply())
            .withBadges(
                new BadgesResponseBuilder()
                    .withActivityHighlights(new BadgeResponseBuilder().withBadgeType().withEnrichmentData())
                    .withDeals(new BadgeResponseBuilder().withBadgeType().withEnrichmentData())
                    .withBookingInfo(new BadgeResponseBuilder().withBadgeType().withEnrichmentData())
                    .withKeyAttributes(new BadgeResponseBuilder().withBadgeType().withEnrichmentData())
                    .withPromocodes(new BadgeResponseBuilder().withBadgeType().withEnrichmentData()),
            ),
    );
    if (withPerPax) {
        pricingResponseBuilder.withPerPax(
            new SummaryElementResponseBuilder()
                .withDisplayType()
                .withQuantity()
                .withTotal(
                    new DisplayTotalPriceResponseBuilder()
                        .withExclusive(new ChargeAmountResponseBuilder().withChargeTotal().withCrossedOut())
                        .withAllInclusive(new ChargeAmountResponseBuilder().withChargeTotal().withCrossedOut()),
                )
                .withLoyaltyOffers(
                    new LoyaltyOfferResponseBuilder()
                        .withLoyaltyOfferType()
                        .withLoyaltyToken()
                        .withEarnOffer(new EarnLoyaltyOfferResponseBuilder().withPoints())
                        .withBurnOffer(new BurnLoyaltyOfferResponseBuilder().withPoints().withUserPayableAmount().withItemPriceInPoints()),
                ),
        );
    }
    return pricingResponseBuilder;
};
